import { apiClient } from '../api/client';

/** A recompensa que o jogador ganhou por vincular. */
export type DiscordLinkReward =
  | { id: string; type: 'CREDIT'; credits: number; grantedAt: string }
  | { id: string; type: 'GIFT'; code: string | null; productName: string | null; redeemed: boolean; grantedAt: string };

/** O que a loja dá a quem vincular, mostrado antes do vínculo. */
export type DiscordLinkOffer = { type: 'CREDIT'; credits: number } | { type: 'GIFT'; productName: string };

export interface CompletedDiscordLink {
  discordUserId: string;
  username: string;
  reward: DiscordLinkReward | null;
  /** A loja dá recompensa, mas esta conta do Discord é nova demais para ela. */
  rewardSkipped: 'account_too_new' | 'already_rewarded' | 'product_unavailable' | null;
}

export interface MyDiscordLink {
  /** Dá para vincular agora? Só com o bot da loja no servidor dela. */
  available: boolean;
  guildName: string | null;
  link: {
    discordUserId: string;
    username: string;
    avatarUrl: string | null;
    linkedAt: string;
  } | null;
  reward: DiscordLinkReward | null;
  offer: DiscordLinkOffer | null;
}

const base = (storeId: string) => `/public/stores/${storeId}/discord/link`;

/**
 * O vínculo da conta do Discord do jogador logado.
 *
 * O jogador sai da sessão, nunca de parâmetro: nenhuma destas rotas recebe id
 * de jogador.
 */
export const discordService = {
  /** `null` quando o módulo não existe na loja (a API responde 404). */
  async getMine(storeId: string): Promise<MyDiscordLink | null> {
    try {
      return await apiClient.get<MyDiscordLink>(base(storeId));
    } catch (error: any) {
      if (error?.response?.status === 404) return null;
      throw error;
    }
  },

  /** Endereço de autorização no Discord, com o `state` preso a esta sessão. */
  async start(storeId: string): Promise<string> {
    const { authorizeUrl } = await apiClient.post<{ authorizeUrl: string }>(`${base(storeId)}/start`);
    return authorizeUrl;
  },

  complete(storeId: string, code: string, state: string) {
    return apiClient.post<CompletedDiscordLink>(`${base(storeId)}/complete`, { code, state });
  },

  unlink(storeId: string) {
    return apiClient.delete<void>(base(storeId));
  },
};
